/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateContainerCommand } from '../../models/update-container-command';
import { UpdateContainerCommandResult } from '../../models/update-container-command-result';

export interface ApiContainersUpdateContainerPatch$Plain$Params {
      body?: UpdateContainerCommand
}

export function apiContainersUpdateContainerPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiContainersUpdateContainerPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateContainerCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiContainersUpdateContainerPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateContainerCommandResult>;
    })
  );
}

apiContainersUpdateContainerPatch$Plain.PATH = '/api/Containers/UpdateContainer';
